import { ExchangeExecutor } from '../../Executors';
import { useStandardRedeem } from './hooks/useStandardRedeem';
import { useStandardRedeemQuote } from './hooks/useStandardRedeemQuote';

export const StandardRedeemExecutor: ExchangeExecutor = {
  useQuote: useStandardRedeemQuote,
  useSwap: useStandardRedeem,
  getSwapArgs: ({ inputToken, outputToken, inputAmount, quoteData, address }) => ({
    inputToken,
    outputToken,
    inputAmount,
    minOutputAmount: quoteData.formattedAmountOut,
    adapter: quoteData.bestCandidate.adapter,
    adapterData: quoteData.bestCandidate.data,
    receiver: address,
  }),
};